import {useQuery} from "@tanstack/react-query";
import {getTopGamesService} from "../../services/games/gamesList/topGames.service";
import {isVisibleGame} from "../../util/hiddenGames";

export const useGetTopGames = (params = {}) => {
  const {data, isPending} = useQuery({
    queryKey: ["topGames", params],
    queryFn: () => getTopGamesService(params),
    select: responseData => {
      const games = responseData?.data?.data || [];
      return {...responseData, data: {...responseData?.data, data: games.filter(isVisibleGame)}};
    },
  });
  return {
    data,
    isPending,
  };
};
